// @flow
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import type { Module } from 'vuex'
import type {OrderSummary} from '../../../types/order-summary'

export type OrderState = {
  ordersForCurrentFilter: OrderSummary[],
  totalNoOrdersForCurrentFilter: number,
  ordersCurrentPageNumber: number,
  ordersPageSize: number,
  ordersOrderBy: ?string,
  ordersOrderDirection: ?string,
}
const initialState = (): OrderState => {
  return {
    ordersForCurrentFilter: [],
    totalNoOrdersForCurrentFilter: 0,
    ordersCurrentPageNumber: 0,
    ordersPageSize: 10,
    ordersOrderBy: 'orderDate',
    ordersOrderDirection: 'DESC'
  }
}

export type OrderModule = Module<OrderState>

const orderModule: OrderModule = {
  namespaced: true,
  state: initialState(),
  initialState: initialState(),
  getters,
  mutations,
  actions
}

export default orderModule



// WEBPACK FOOTER //
// ./src/store/modules/order/index.js